<template>
  <SfDrawerToggle
    :content="content"
    :position="position"
    :hide-if-open="hideIfOpen"
    @hidden="hideHost"
    @shown="showHost"
  >
    <slot />
  </SfDrawerToggle>
</template>

<script lang="ts" setup>
import type {
  LeftDrawerContent,
  RightDrawerContent,
} from '@app/shared/types/drawer'

import { useHost } from 'vue'

import SfDrawerToggle from '@app/shared/vue/connected/sf-drawer-toggle.vue'

interface BaseProps {
  hideIfOpen?: boolean
}

interface LeftDrawerProps extends BaseProps {
  position: 'left'
  content: LeftDrawerContent
}

interface RightDrawerProps extends BaseProps {
  position: 'right'
  content: RightDrawerContent
}

type Props = LeftDrawerProps | RightDrawerProps

defineProps<Props>()

const host = useHost()

function hideHost() {
  if (host) {
    host.style.display = 'none'
  }
}

function showHost() {
  if (host) {
    host.style.display = ''
  }
}
</script>
<style lang="scss">
@import '@app/shared/vue/connected/sf-drawer-toggle';
</style>
